import { useEffect, useRef } from 'react'

const SCRIPT_SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
// Micro Review Count — compact inline widget showing stars + score + review count
const TEMPLATE_ID = '5419b732fbfb950b10de65e5'

const TrustpilotWidget = ({ businessUnitId, locale = 'en-GB' }) => {
  const ref = useRef(null)

  useEffect(() => {
    if (!businessUnitId || !ref.current) return

    const init = () => {
      if (window.Trustpilot && ref.current) {
        window.Trustpilot.loadFromElement(ref.current, true)
      }
    }

    if (window.Trustpilot) {
      init()
      return
    }

    let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
    if (!script) {
      script = document.createElement('script')
      script.src = SCRIPT_SRC
      script.async = true
      document.head.appendChild(script)
    }
    script.addEventListener('load', init)
    return () => script.removeEventListener('load', init)
  }, [businessUnitId, locale])

  if (!businessUnitId) return null

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={businessUnitId}
      data-style-height="24px"
      data-style-width="100%"
      data-theme="light"
      style={{ marginTop: '0.4rem' }}
    >
      <a href="https://www.trustpilot.com" target="_blank" rel="noreferrer noopener">Trustpilot</a>
    </div>
  )
}

export default TrustpilotWidget
